import React, { Component } from "react";
import { Card, Form, Button, Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";

export default class UpdatePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      empId: "",
      empData: [],
      password: "",
      errors: {},
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      loading: true,
      color: ''
    };
  }

  componentDidMount() {
    this.fecthEmpList();
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...this.state.errors };
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({ [name]: value, errors });
  };

  validateForm = () => {
    const errors = {};
    const password = this.state.password.trim();
    const empId = this.state.empId;

    if (!password) {
      errors.password = "Password is required";
    }
    else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }
    else if (password.length > 30) {
      errors.password = "Password must not exceed 300 characters";
    }
    if (!empId) {
      errors.empId = "Please select a Employee";
    }
    return errors;
  };

  fecthEmpList = async () => {
    axios({
      method: 'get',
      url: '/users',
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
      .then(res => {
        this.setState({
          empData: res.data,
          loading: false
        });
      })
      .catch(err => {
        console.log(err);
      });
  };


  onSubmit = async (e) => {
    e.preventDefault();
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    this.setState({ loading: true });
    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const payload = {
        password: this.state.password,
        id: this.state.empId,

      };
      let itemStatusResponse;
      itemStatusResponse = await axios.post('/users/emp-password-update', payload, { headers });
      debugger;
      this.setState({
        password: "",
        errors: {},
        showToast: true,
        toastMessage: itemStatusResponse.data.message ? itemStatusResponse.data.message : "Password updated successfully!",
        toastVariant: "success",
        color: 'green',
        loading: false,
      },
        () => {
          setTimeout(() => {
            this.setState({ loading: false, password: "", empId: '' });
          }, 600);
        });


    } catch (error) {
      this.setState({
        showToast: true,
        toastMessage: error.response?.data?.message || "Error Updating password",
        toastVariant: "danger",
        color: 'red',
        loading: false,
      });
    }
  };

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, password: "", empId: '' });
    }, 500);
  };

  render() {
    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          <Container className=" pt-4">
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="bg-gray text-white">
                <strong>Update Password</strong>
              </Card.Header>
              <Card.Body>
                <Form onSubmit={this.onSubmit}>
                  <Row className="mb-3">
                    <Col xs={12} md={6} lg={6}>
                      <Form.Group controlId="uomSelect">
                        <Form.Label className="text-muted required">Employee List</Form.Label>
                        <Form.Control
                          as="select"
                          name="empId"
                          className="form-select"
                          value={this.state.empId}
                          onChange={this.handleChange}
                          isInvalid={!!this.state.errors.empId}
                        >
                          <option value="" >Select Employee</option>
                          {this.state.empData
                            .filter(emp => emp.id !== 1)
                            .map(emp => (
                              <option key={emp.id} value={emp.id}>
                                {emp.fullName} ({emp.id})
                              </option>
                            ))
                          }
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.empId}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                      <Form.Group controlId="formName">
                        <Form.Label className="text-muted required">Password</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter password"
                          name="password"
                          value={this.state.password}
                          onChange={this.handleChange}
                          isInvalid={!!this.state.errors.password}
                        />
                        <Form.Control.Feedback type="invalid">
                          {this.state.errors.password}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className='add-cancel-btn '>
                    <Button variant="primary" type="submit" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary">
                      Update
                    </Button>
                    <Button variant="danger" className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel " onClick={this.handleBack}>Cancel</Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Container>
        </CommonLoader>
      </>
    );
  }
}
